module.exports = __webpack_public_path__ + "1b8288ca1b36276c4ddcf945ac5ca5fd.png";